// CRA emits one content-hashed entry bundle per build, so its file name is
// the build id. Dev server serves an unhashed bundle.js, which never matches.
const MAIN_SCRIPT_RE = /\/static\/js\/main\.[0-9a-f]+\.js/;

/** @type {(html: string) => string|null} */
export const extractBuildId = (html) =>
  String(html ?? "").match(MAIN_SCRIPT_RE)?.[0] ?? null;

/** @type {(doc?: Document) => string|null} */
export const currentBuildId = (doc = document) =>
  Array.from(doc.querySelectorAll("script[src]"))
    .map((script) => extractBuildId(script.getAttribute("src")))
    .find(Boolean) ?? null;

/** @type {() => Promise<string|null>} */
export const fetchLatestBuildId = () =>
  fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" })
    .then((response) => (response.ok ? response.text() : null))
    .then(extractBuildId)
    .catch(() => null);

export const isNewBuild = (current, latest) =>
  Boolean(current && latest && current !== latest);

/** webpack's lazy-chunk failure after a deploy removed the old chunk files. */
export const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk [\w-]+ failed/i.test(String(error?.message ?? ""));
